import { useAppStore } from './app.js'

const store = {
  app: null,
  init() {
    store.app = useAppStore()
  }
}

export { store }
